import dayjs from 'date'
import { useQuery } from 'hooks'
import { useCallback, useMemo } from 'react'
import links, { getLinkWithParams } from 'links'


type CityEvent = {
  id: number
  title: string
  bookmarked: boolean
  image: string
  type: string
  start: string
  end: string
  to: string
}

const useEvents = () => {
  const options = useMemo(() => ({
    url: `/api/afisha/events?per_page=3&sort[is_main]=desc&sort[started_at]=asc
      &sessions_from=${dayjs().format('YYYY-MM-DD')}&sessions_to=${dayjs().add(3, 'month').format('YYYY-MM-DD')}`,
    modifyResult: ({ data }) => {
      return data?.map((event) => {
        const { id, title, image_previews: images, type, bookmarked, started_at: start, ending_at: end } = event

        return {
          id, title, bookmarked,
          image: images?.large,
          type: type?.name,
          start: dayjs(start).format('DD MMMM'),
          end: end && dayjs(end).format('DD MMMM'),
          to: getLinkWithParams(links.events.item, { itemId: id }),
        }
      })
    },
  }), [])

  const { data, isFetching, errors } = useQuery<CityEvent[]>(options)

  const handleToggleBookmark = useCallback((id: number) => {
    // axios.post(`/api/react/bookmark/afisha-event/${id}?api_token=${rirApiToken}`)
  }, [])

  const events = useMemo(() => {
    if (data) {
      return data
    }

    return []
  }, [ data ])

  return {
    events,
    isFetching,
    handleToggleBookmark,
  }
}

export default useEvents